@for (noty of noties(); track noty.id) {
  <div class="noty"
    [class.noty-info]="noty.type === 'info'"
    [class.noty-error]="noty.type === 'error'"
    [class.noty-hiding]="noty.isHiding"
    >
    {{ noty.message }}
    <div
      class="noty-close"
      (click)="hideNoty(noty)"
    >
      <tc-icon class="noty-close-icon" name="close"></tc-icon>
    </div>
  </div>
}
